import React from "react";

// Shared input chrome (border/focus ring/disabled state) so every form
// field in the app looks the same. Pass any native <input>/<select>/
// <textarea> props straight through.
export const inputClass =
  "w-full px-3 py-2 text-sm border border-slate-300 rounded-md text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-600/40 focus:border-blue-600 disabled:bg-slate-100 disabled:text-slate-500 transition-colors";

/**
 * Labeled form field wrapper. Renders its own <label> and helper/error text;
 * pass the actual input as `children` (or use the `as`/`inputProps` shortcut
 * for a plain <input>).
 */
const Field = ({ label, required, hint, error, className = "", children, as = "input", inputProps }) => {
  const Comp = as;
  return (
    <div className={className}>
      {label && (
        <label className="block text-xs font-medium text-slate-600 mb-1.5">
          {label} {required && <span className="text-rose-500">*</span>}
        </label>
      )}
      {children || <Comp className={inputClass} required={required} {...inputProps} />}
      {hint && !error && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
      {error && <p className="text-xs text-rose-600 mt-1">{error}</p>}
    </div>
  );
};

export default Field;
